/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordValidationRuleset } from './PasswordValidationRuleset';
import {
    PasswordValidationRulesetFromJSON,
    PasswordValidationRulesetFromJSONTyped,
    PasswordValidationRulesetToJSON,
} from './PasswordValidationRuleset';

/**
 * 
 * @export
 * @interface PasswordResetChallengeOptions
 */
export interface PasswordResetChallengeOptions {
    /**
     * 
     * @type {PasswordValidationRuleset}
     * @memberof PasswordResetChallengeOptions
     */
    validation_rules: PasswordValidationRuleset;
}

/**
 * Check if a given object implements the PasswordResetChallengeOptions interface.
 */
export function instanceOfPasswordResetChallengeOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "validation_rules" in value;

    return isInstance;
}

export function PasswordResetChallengeOptionsFromJSON(json: any): PasswordResetChallengeOptions {
    return PasswordResetChallengeOptionsFromJSONTyped(json, false);
}

export function PasswordResetChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetChallengeOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'validation_rules': PasswordValidationRulesetFromJSON(json['validation_rules']),
    };
}

export function PasswordResetChallengeOptionsToJSON(value?: PasswordResetChallengeOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'validation_rules': PasswordValidationRulesetToJSON(value.validation_rules),
    };
}

